import { useMediaQuery, useTheme } from '@mui/material'
import { Box, Drawer, IconButton } from '@mui/material'
import * as Icons from '@mui/icons-material'
import {
  DESKTOP_DRAWER_WIDTH,
  COLLAPSED_DESKTOP_DRAWER_WIDTH,
  DESKTOP_BREAKPOINT,
  MOBILE_DRAWER_WIDTH,
} from '~/common/constants/layout-constants'
import { useFeatures } from '~/common/use-features'
import { useAuthContext } from '~/common/context/auth/auth-context'
import theme from '~/styles/mui-theme'
import { drawerPaperSx, collapseButtonSx } from './sidebar-styles'
import { DrawerContent } from './drawer-content'

const Sidebar = ({ mobileOpen, onClose, collapsed, onCollapsedToggle }) => {
  const { palette } = useTheme()
  const { user: authUser } = useAuthContext()
  const { features } = useFeatures()
  const isDesktop = useMediaQuery(theme.breakpoints.up(DESKTOP_BREAKPOINT))

  if (!authUser) return null

  const currentDrawerWidth = collapsed ? COLLAPSED_DESKTOP_DRAWER_WIDTH : DESKTOP_DRAWER_WIDTH

  return isDesktop ? (
    <Box
      component="nav"
      sx={{
        width: currentDrawerWidth,
        flexShrink: 0,
        position: 'relative',
        transition: (theme) =>
          theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
      }}
    >
      <Drawer
        variant="persistent"
        sx={drawerPaperSx(currentDrawerWidth)}
        open
      >
        <DrawerContent collapsed={collapsed} isDesktop={isDesktop} onClose={onClose} />
      </Drawer>

      {features['sidebar_collapse'] && (
        <IconButton
          onClick={onCollapsedToggle}
          size="small"
          sx={{
            ...collapseButtonSx({ collapsed, palette }),
            '& .MuiSvgIcon-root': { fontSize: 18 }, // reduce icon size
          }}
        >
          {collapsed ? <Icons.ChevronRight fontSize="inherit" /> : <Icons.ChevronLeft fontSize="inherit" />}
        </IconButton>
      )}
    </Box>
  ) : (
    <Box component="nav" sx={{ flexShrink: 0, position: 'relative' }}>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onClose}
        ModalProps={{ keepMounted: true }}
        sx={{ '& .MuiDrawer-paper': { boxSizing: 'border-box', width: MOBILE_DRAWER_WIDTH } }}
      >
        <DrawerContent collapsed={collapsed} isDesktop={isDesktop} onClose={onClose} />
      </Drawer>
    </Box>
  )
}

export default Sidebar
